
<template>
	<div class="footerWraper">


		<div class="footer">
			<div v-for='(item,index) of items' :class='[item.cls,{on:index === idx}]' @click="goUserinfo(item.push)">
				<img :src="index===idx?item.iconSelect:item.icon" class="icon">
				<p :class="['colorChange',{on:index===idx}]" >{{item.name}}</p>
			</div>

		</div>
	</div>
</template>

<script type="text/javascript">

export default{
	name:'navBar',
	props:['idx'],
	data(){
		return {
			items:[{
				cls:"home",
				name:"首页",
				push:"/",
				icon:require("@/static/images/tabbar/home.png"),
				iconSelect:require("@/static/images/tabbar/home_red.png")
			},
			{
				cls:"order",
				name:"历史订单",
				push:"/historycard",
				icon:require("@/static/images/tabbar/order.png"),
				iconSelect:require("@/static/images/tabbar/order_red.png")
			},
			{
				cla:"customer",
				name:"在线客服",
				push:"/customer",
				icon:require("@/static/images/tabbar/kefu.png"),
				iconSelect:require("@/static/images/tabbar/kefu_red.png")
			},
			{
				cla:"mine",
				name:"个人中心",
				push:"/mine",
				icon:require("@/static/images/tabbar/user.png"),
				iconSelect:require("@/static/images/tabbar/user_red.png")
			}]
		}
	},


	methods:{
		goUserinfo(t){
         this.$router.push(
            t,
            onComplete => {},
            onAbort => {}
         )
      }
	}

}

</script>
<style scoped>
.footerWraper{
	position: fixed;
	bottom:0;
	max-width: 750px;
	width:100%;
	/* height: 60px; */
  height: 62px;
	left:50%;
	right:0;
	transform:translateX(-50%);
	z-index:999;
	font-size: 14px;

}
.footer{
	width: 100%;
	/* height: 60px; */
  height: 62px;
	display:flex;
	flex-direction:row;
	justify-content:space-around;
	background-color:#fff;
  border-top: 1px solid #DDDDDD;
}

.footer div{
	width:25%;
	overflow:hidden;
}
.icon{
	/* width:1.2rem; */
  width: auto;
  height: 30px;
	/* height: 1.2rem; */
	/* margin-top: .5em; */
  margin-top: 6px;
}
.footer p{
	/* margin-top:0; */
	/* margin-bottom:0.5em; */
	/* font-size: 14px; */
  font-size: 10px;
  color: #686777;
  line-height: 15px;
  margin-top: 2px;
  font-family: 思源黑体 CN;
}
.colorChange.on{
	color:#b22830;
}
</style>



// WEBPACK FOOTER //
// src/components/navBar.vue